//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation,  } from "react-router-dom";

//css
import styled from "styled-components"

// component
import MyEdit from "./components/MyEdit"

export default function MyEditPage() {

    return (
        <MyEdit/>
    );
  }

